module.exports = __webpack_public_path__ + "static/Положение_о_Совете_ГС_ИТ_РСЯ_(ред_от_19_10_2018).doc";